import buildMeta from '../utils/buildMeta'

const routes = [
  {
    name: 'account',
    path: '/account-settings',
    component: () => import('@/pages/Account/Account.vue'),
    meta: buildMeta({
      authRequired: true,
      hideDistractions: true,
    }),
    children: [
      {
        name: 'account-landing',
        path: '',
        component: () => import('@/pages/Account/Landing.vue'),
        meta: buildMeta({
          pageTitle: 'Account',
          layout: 'fullWidth',
          title: 'Account Settings - Jobscan',
        }),
      },
      {
        name: 'account-personal',
        path: 'personal-info',
        component: () => import('@/pages/Account/Personal.vue'),
        meta: buildMeta({
          pageTitle: 'Personal info',
          title: 'Personal Info - Account Settings - Jobscan',
        }),
      },
      {
        name: 'account-jobsearch',
        path: 'job-match',
        component: () => import('@/pages/Account/JobSearch.vue'),
        meta: buildMeta({
          pageTitle: 'Job match',
          title: 'Job Search - Account Settings - Jobscan',
        }),
      },
      {
        name: 'account-security',
        path: 'login-and-security',
        component: () => import('@/pages/Account/LoginSecurity.vue'),
        meta: buildMeta({
          pageTitle: 'Login & security',
          title: 'Login & Security - Account Settings - Jobscan',
        }),
      },
      {
        name: 'account-subscription',
        path: 'subscription',
        component: () => import('@/pages/Account/Subscription.vue'),
        meta: buildMeta({
          pageTitle: 'Subscription',
          title: 'Your Subscription - Account Settings - Jobscan',
        }),
      },
      {
        name: 'account-referrals',
        path: 'referrals',
        component: () => import('@/pages/Account/Referrals.vue'),
        meta: buildMeta({
          pageTitle: 'Referrals',
          altPageTitle: 'Get up to 200 Jobscan resume scans for free!',
          layout: 'fullWidth',
          title: 'Invite your friends - Account Settings - Jobscan',
        }),
      },
      {
        name: 'account-communication',
        path: 'communication',
        component: () => import('@/pages/Account/Communication.vue'),
        meta: buildMeta({
          pageTitle: 'Communications',
          title: 'Communications - Account Settings - Jobscan',
        }),
      },
    ],
  },
  {
    name: 'account-cancel',
    path: '/account-settings/cancel-subscription',
    component: () => import('@/pages/Account/Cancel.vue'),
    meta: buildMeta({
      authRequired: true,
      pageTitle: 'Cancel your Subscription',
      layout: 'fullWidth',
      hideDistractions: true,
      liveChatEnabled: true,
      title: 'Cancel Subscription - Account Settings - Jobscan',
    }),
  },
  {
    name: 'account-confirm-cancellation',
    path: '/account-settings/cancel-subscription/confirm',
    component: () => import('@/pages/Account/CancelConfirmation.vue'),
    meta: buildMeta({
      authRequired: true,
      pageTitle: 'Cancel your Subscription',
      layout: 'fullWidth',
      hideDistractions: true,
      liveChatEnabled: true,
      title: 'Cancel Subscription - Account Settings - Jobscan',
    }),
  },
  {
    name: 'account-cancel-complete',
    path: '/account-settings/cancel-subscription/complete',
    component: () => import('@/pages/Account/CancelComplete.vue'),
    meta: buildMeta({
      authRequired: true,
      pageTitle: 'Cancel your Subscription',
      layout: 'fullWidth',
      hideDistractions: true,
      liveChatEnabled: true,
      title: 'Cancel Subscription - Account Settings - Jobscan',
    }),
  },
]

export default routes
